const getSearchParams = () => new URLSearchParams(window.location.search);

export default getSearchParams;
